import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d35ce38"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "learnCode",
  tabindex: "-1"
}

import { ElIcon } from "element-plus";
  import { Goods } from "@element-plus/icons-vue";
  import store from "@/store";
  
export default /*#__PURE__*/_defineComponent({
  __name: 'BenefitCourse',
  setup(__props) {

  function openDialog() {
    store.commit("SET_BENEFITCOURSEFLAGDIALOG", true);
  }
  
return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_tooltip, {
      class: "box-item",
      effect: "dark",
      content: _ctx.$t('福利课程'),
      placement: "left"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "icon g-flex-jc-center g-flex-al-center g-pointer",
          onClick: openDialog
        }, [
          _createVNode(_unref(ElIcon), { size: "25" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Goods))
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["content"])
  ]))
}
}

})